import { useQuery } from '@tanstack/react-query'
import type { RiskAssessment } from '@mobi/api-types'
import { get, queryKeys, SignUpUrl } from '../../../Utils'

export const useRiskAssessment = (options: { enabled?: boolean } = {}) => {
  return useQuery<RiskAssessment>({
    queryKey: [queryKeys.riskAssessment],
    queryFn: getRiskAssessment,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: options.enabled ?? true,
  })
}

export function getRiskAssessment() {
  return get<RiskAssessment>(SignUpUrl.riskAssessment)
}
